/**
 * Set document.title for the lifetime of a page.
 *
 * Use at the top of every page component:
 *
 *   usePageTitle("Tickets");
 *
 * The hook composes the supplied title with the app name to produce
 * "Tickets - Buyist Support" in the browser tab.
 */
import { useEffect } from "react";

const APP_NAME = "Buyist Support";

export function usePageTitle(title: string | null | undefined): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} - ${APP_NAME}` : APP_NAME;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
